import { SampleStatus } from '../../utils/sampleUtils'
import {
  Mtds,
  WarningIcon,
  CheckCircleIcon,
  FileIcon,
  HourglassMediumIcon,
  CircleIcon
} from 'prove-common'

const STATUS_ICON: Record<SampleStatus[number], React.ReactNode> = {
  [SampleStatus?.sample_created]: <HourglassMediumIcon />,
  [SampleStatus?.analysis_started]: <CircleIcon />,
  [SampleStatus?.ready_to_process]: <FileIcon />,
  [SampleStatus?.completed]: <CheckCircleIcon />,
  [SampleStatus?.closed]: <CheckCircleIcon />,
  [SampleStatus?.compromised]: <WarningIcon />
}

type SampleStatusTagProps = {
  status: SampleStatus
}

export const SampleStatusTag = ({ status }: SampleStatusTagProps) => (
  <Mtds.Tag data-icon='none' data-color='neutral'>
    {STATUS_ICON[status]}
    {status}
  </Mtds.Tag>
)
